import xpSolvService from "../axios/axios";

class UserService {

    updateUser(params,data) {
        return Promise.resolve(xpSolvService.put(`ordertest/register/studentdetails/${params}`, data));
    }
}

export default UserService;